export default "__VITE_ASSET__821b356e__"